import { supabase } from '@/lib/supabaseClient';
import { TABLE_NAMES } from '@/lib/constants';

export interface ConceptoDeDeuda {
  id_concepto_deuda?: string;
  id_deuda: string;
  tipo: string;
  descripcion?: string;
  monto: number;
}

export const debtConceptService = {
  async getConceptsByDebt(debtId: string) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.CONCEPTO_DE_DEUDA)
      .select('*')
      .eq('id_deuda', debtId);
    if (error) throw error;
    return data;
  },

  async createConcept(concept: ConceptoDeDeuda) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.CONCEPTO_DE_DEUDA)
      .insert([concept])
      .select();
    if (error) throw error;
    return data[0];
  },

  async updateConcept(id: string, updates: Partial<ConceptoDeDeuda>) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.CONCEPTO_DE_DEUDA)
      .update(updates)
      .eq('id_concepto_deuda', id)
      .select();
    if (error) throw error;
    return data[0];
  },

  async deleteConcept(id: string) {
    const { error } = await supabase
      .from(TABLE_NAMES.CONCEPTO_DE_DEUDA)
      .delete()
      .eq('id_concepto_deuda', id);
    if (error) throw error;
    return true;
  },
};
